import { render, staticRenderFns } from "./SendNotification.vue?vue&type=template&id=17148094&scoped=true"
import script from "./SendNotification.vue?vue&type=script&lang=js"
export * from "./SendNotification.vue?vue&type=script&lang=js"
import style0 from "./SendNotification.vue?vue&type=style&index=0&id=17148094&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17148094",
  null
  
)

export default component.exports